import React from 'react';
import {BaseConfig} from '../BaseConfig';

import "./progress-bar1.css"
import { getGlobalTextSizeStyle, TextHtmlTagType } from '../../misc/tools';

const ProgressBar1 = (props: ProgressBar1Config) => {
    return (
        <div className="modal-disable-select progress-bar1-container" style={{}}>
            <p style={{
                color: props.textColor ?? 'white',
                ...getGlobalTextSizeStyle(TextHtmlTagType.p)
            }} className={`small-text`}>{props.title}</p>
            <div className={'progress-bar1-bar center-element-horizontal ' + ((props.percentage * 100) >= 40 ? 'text-white' : '')}>
                <div className='progress-bar1-bar-inner' style={{
                    width: (props.percentage * 100) + '%',
                }}></div>
                <p style={{
                    color: 'white',
                    ...getGlobalTextSizeStyle(TextHtmlTagType.p)
                }} className={`default-text center-element`}>{Math.round(props.percentage * 100) + '%'}</p>
            </div>
        </div>
    );

};

export interface ProgressBar1Config extends BaseConfig {
    title?: string;
    percentage?: number;
    textColor?: string;
}

export default ProgressBar1;